import { defineComponent, h, PropType } from 'vue';
import { coming_soon } from '@components/icons';
import { State } from '../../state';
import BarButton from '@components/bar-button';
import { clipping_model_editable, clipping_on } from '@features/clipping';
import project_svg from '../../../assets/img/SVG_icons/Top/editing_model/project_edges.svg';
import { img } from '@phi/components';
import { complete_or_abort_projecting_edges_onto_faces, prepare_project_edges_onto_faces } from '@frontend/ui_display';
import ProjectEdgesTooltip from './ProjectEdgesTooltip';
import { ISubscriptions } from '@phi/subscriptions/frontend';

export const ProjectIcon = project_svg;

export default defineComponent({
    props: {
        state: { required: true, type: Object as PropType<State> },
        subscriptions: { required: true, type: Object as PropType<ISubscriptions> },
    },

    computed: {
        coming_soon() {
            return !this.state.loaded;
        },

        alt() {
            return 'Project edges onto faces';
        },

        disabled() {
            return !this.state.loaded
                || (this.total_selected_elements === 0 && ! this.state.projecting_edges)
                || this.state.editing_reference_partstudio
                || this.state.editing_reference_sketches
                || this.state.editing_reference_stl
                || this.state.rigid_move_manipulator
                || (
                    clipping_on.value
                    && !clipping_model_editable.value
                );
        },

        active() {
            return this.state.projecting_edges;
        },

        total_selected_elements() {
            return this.state.selected_edges_count
                + this.state.selected_faces_count
                + this.state.selected_vertices_count;
        }
    },

    watch: {
        disabled(value: boolean) {
            this.$emit('update:disabled', value);
        },
    },

    emits: {
        'update:disabled': (x: boolean) => true,
    },

    methods: {
        onClick() {
            if (this.disabled)
                return;
            else if (this.state.projecting_edges)
                complete_or_abort_projecting_edges_onto_faces();
            else
                prepare_project_edges_onto_faces();
        },
    },

    render() {
        return h(BarButton, {
            id: 'project-edges-button',
            tippy: 'left',
            onClick: this.onClick,
            active: this.state.projecting_edges,
            selected: this.state.tut_stage === 5,
            disabled: this.disabled,
            help: 'project_edges',
        }, {
            icon: () => this.coming_soon ? coming_soon(this.alt) : img(project_svg, this.alt),
            tooltip: ProjectEdgesTooltip,
        });
    },
});
